import { render, staticRenderFns } from "./newsinfo.vue?vue&type=template&id=50410324&scoped=true&"
import script from "./newsinfo.vue?vue&type=script&lang=js&"
export * from "./newsinfo.vue?vue&type=script&lang=js&"
import style0 from "./newsinfo.vue?vue&type=style&index=0&id=50410324&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50410324",
  null
  
)

export default component.exports